import React from "react";
import Avatar from "@/js/components/shared/Avatar";
import { User, userDisplayText } from "@/js/utils/userUtils";
import { ChatThread } from "../types";
import { Text } from "@chakra-ui/react";

interface Props {
	/** The student user object */
	student: User;
	/** Function called when student is selected */
	onSelect: (username: string, threadKey?: string) => void;
	/** Optional thread object containing message data */
	thread?: ChatThread;
	/** Optional thread key as fallback */
	threadKey?: string;
	/** Whether there are unread messages */
	hasUnreadMessages?: boolean;
}

const StudentRow: React.FC<Props> = ({ student, onSelect, thread, threadKey, hasUnreadMessages = false }) => {
	if (!student) {
		return null;
	}

	const handleSelect = (): void => {
		// If thread object is not found, still pass the threadKey as fallback
		onSelect(student.username, thread?.threadKey ?? threadKey);
	};

	return (
		<button className="ClassroomChatroom_rowContainer" onClick={handleSelect} type="button">
			<div className="Classroom_rowWrapper">
				<Avatar />
				<div className="ClassroomChatroom_student">
					<Text className="ClassroomChatStudentsList_name">{userDisplayText(student)}</Text>
					{thread && thread.message && <Text className="ClassroomChatStudentsList_message">{thread.message}</Text>}
				</div>
				{hasUnreadMessages && (
					<div className="ClassroomChat_notificationsContainer">
						<div className="ClassroomChat_notificationsValue"></div>
					</div>
				)}
			</div>
		</button>
	);
};

export default StudentRow;
